import { documentDefaultDay, staleSendWarning, t, type StaleSendDocument, type StaleSendWarning } from '@bms2/shared';
import { AlertBanner } from '../../components/controls/AlertBanner';

/**
 * 🔒 The stale first-send warning in a send window (piece 22; decision 1227, T421).
 * The answer carries the document's date and the Settings row's figure while the
 * document awaits its first send; the window measures the gap from today in the
 * viewer's own zone (decision 1030), the day the server's check reads for the same
 * person. A resend's answer carries no basis, so it warns nothing.
 */
export interface StaleSendBasisView {
  documentDate: string;
  thresholdDays: number;
}

export function staleSendFor(documentType: StaleSendDocument, basis: StaleSendBasisView | null | undefined, zone: string, now: Date = new Date()): StaleSendWarning | null {
  if (!basis) return null;
  return staleSendWarning({ documentType, firstSend: true, documentDate: basis.documentDate, today: documentDefaultDay(now, zone), thresholdDays: basis.thresholdDays });
}

/** The warning naming the date and the gap; its one action is Change the Date, and the window's primary becomes Send Anyway. */
export function StaleSendBanner({ warning, onChangeDate }: { warning: StaleSendWarning | null; onChangeDate: () => void }) {
  if (!warning) return null;
  return (
    <div data-stale-send={warning.days} data-stale-send-date={warning.documentDate}>
      <AlertBanner tone="warning" message={warning.sentence} action={{ label: t('document.staleSend.changeDate'), onAction: onChangeDate }} />
    </div>
  );
}
